import { useEffect, useState } from 'react';

const MOBILE_MEDIA_QUERY = '(max-width: 768px)';

// Evaluate the media query synchronously for the initial state so the very first render
// is already correct. Previously this defaulted to false (desktop): on a phone the
// desktop content view painted for one frame (its hero is max-h ~480px, ~2/3 of the
// screen) before the effect flipped it to mobile and the layout swapped to the
// full-bleed image + tray — reading as the image flashing tall then shrinking. (VIS-366)
const getIsMobileScreen = (): boolean => {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false;
  }
  return window.matchMedia(MOBILE_MEDIA_QUERY).matches;
};

export const useMobileScreen = () => {
  const [isMobileScreen, setIsMobileScreen] = useState<boolean>(getIsMobileScreen);

  useEffect(() => {
    const mediaQuery = window.matchMedia(MOBILE_MEDIA_QUERY);

    const handleResize = (e: MediaQueryListEvent | MediaQueryList) => {
      setIsMobileScreen(e.matches);
    };

    if (mediaQuery) {
      handleResize(mediaQuery);

      mediaQuery.addEventListener('change', handleResize);
    }

    return () => {
      mediaQuery?.removeEventListener('change', handleResize);
    };
  }, []);

  return { isMobileScreen };
};
